import { API_URL } from "../config/connect";
import { throwResponseError } from '../utils/apiErrorHandler';

const CACHE_TTL_MS = 30_000;
const cache = new Map();

function cacheKey(status, page, size) {
    return `${status}|${page}|${size}`;
}

async function getUserAdd(status, page = 1, size = 10) {
    try {
        const accessToken = localStorage.getItem("access_token");

        if (!accessToken) {
            return;
        }

        const key = cacheKey(status, page, size);
        const cached = cache.get(key);
        if (cached && Date.now() - cached.ts < CACHE_TTL_MS) {
            return cached.data;
        }

        const response = await fetch(`${API_URL}/api/v1/user/announcements/${status}?page=${page}&size=${size}`, {
            method: 'GET',
            cache: 'no-store',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            }
        });

        if (!response.ok) {
            await throwResponseError(response);
        }

        const data = await response.json();
        cache.set(key, { data, ts: Date.now() });
        return data;
    } catch (error) {
        console.error("Error in getFavoriteStatus:", error);
        throw error;
    }
}

function invalidateUserAdsCache() {
    cache.clear();
}

export {getUserAdd, invalidateUserAdsCache};